// extracted by mini-css-extract-plugin
export default {"mobile":"mobile","concidences":"T8lG1Dwt"};